import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty',
  templateUrl: './home-thirty.component.html',
  styleUrls: ['./home-thirty.component.scss']
})
export class HomeThirtyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
